<template>

  <div>
    <Settled v-if="activeName == 'settled'"></Settled>
    <Index v-if="activeName == 'index'"></Index>
    <CoreMembers v-if="activeName == 'core_members'"></CoreMembers>
    <Notice v-if="activeName == 'notice'"></Notice>
    <Situation v-if="activeName == 'situation'"></Situation>
     <Product v-if="activeName == 'product'"></Product>
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Index from './index/index';
import Settled from './settled/settled';
import Notice from './notice/index';
import Situation from './situation/index';
import Product from './product/index';
import CoreMembers from './core_members/core_members.vue';
import Setting from './setting/getSetting';

export default {
  components: {
    Index,
    Settled,
    Product,
    Situation,
    Notice,
    Setting,
    CoreMembers
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'settled',
      /*切换数组*/
      sourceList: [
         {
          key: 'settled',
          value: '入驻申请',
          path:'/plus/enterprise/settled/settled'
        },
        {
          key: 'index',
          value: '详情',
          path:'/plus/enterprise/index/index'
        },
         {
          key: 'core_members',
          value: '核心人员',
          path:'/plus/enterprise/core_members/core_members'
        },
         {
          key: 'notice',
          value: '活动通知',
          path:'/plus/enterprise/notice/index'
        },
          {
          key: 'situation',
          value: '活动情况',
          path:'/plus/enterprise/situation/situation'
        },
         {
          key: 'product',
          value: '特色产品',
          path:'/plus/enterprise/product/product'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/enterprise/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'activity',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'activity'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/enterprise/index.vue